import React, { useState } from "react";

/**
 * LazyImage — image with blur-up skeleton loading state.
 * Shows a subtle pulsing placeholder until the image loads.
 */
const LazyImage = ({ src, alt, className = "", ...rest }) => {
    const [loaded, setLoaded] = useState(false);
    return (
        <div className="relative w-full h-full bg-muted overflow-hidden">
            {!loaded && (
                <div
                    aria-hidden="true"
                    className="absolute inset-0 animate-pulse bg-gradient-to-br from-muted via-muted/60 to-muted"
                />
            )}
            <img
                src={src}
                alt={alt}
                loading="lazy"
                onLoad={() => setLoaded(true)}
                className={`${className} ${
                    loaded ? "opacity-100" : "opacity-0"
                } transition-opacity duration-700`}
                {...rest}
            />
        </div>
    );
};

export default LazyImage;
